const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** How long ago a moment was, in a few characters: "now", "5m", "3h", "2d", then a short date. Empty for a missing or invalid time. */
const formatRelativeTime = (value, now = Date.now()) => {
  const time = typeof value === 'number' ? value : Date.parse(value || '');

  if (!Number.isFinite(time)) {
    return '';
  }

  const elapsed = Math.max(0, now - time);

  if (elapsed < MINUTE) {
    return 'now';
  }
  if (elapsed < HOUR) {
    return `${Math.floor(elapsed / MINUTE)}m`;
  }
  if (elapsed < DAY) {
    return `${Math.floor(elapsed / HOUR)}h`;
  }
  if (elapsed < 7 * DAY) {
    return `${Math.floor(elapsed / DAY)}d`;
  }

  return new Date(time).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

export default formatRelativeTime;
